import { CallAdapter } from './callAdapter';
import { Device } from '@twilio/voice-sdk';

export class TwilioVoiceAdapter extends CallAdapter {
  constructor({ token }) {
    super();
    this.token = token;
    this.device = null;
    this.connection = null;
  }

  async connect({ to, conversationId, callSid }) {
    this.device = new Device(this.token, {
      allowIncomingWhileBusy: true,
      disableAudioContextSounds: true,
    });

    this.device.on('connect', conn => {
      this.connection = conn;
      this.dispatchEvent('connected');
    });

    this.device.on('disconnect', () => {
      this.dispatchEvent('disconnected');
    });

    const params = {
      To: to,
      is_agent: 'true',
      conversation_id: conversationId,
      call_sid: callSid,
    };

    this.connection = await this.device.connect({ params });
  }

  async disconnect() {
    if (this.connection) {
      this.connection.disconnect();
      this.connection = null;
    }
    if (this.device) {
      this.device.destroy();
      this.device = null;
    }
  }

  setMuted(shouldMute) {
    if (this.connection) {
      this.connection.mute(shouldMute);
    }
  }
}
